import {HTTP} from '@/CallAPI'
export default {
  getListDocumentItem (document) {
    return HTTP.get('documents/' + document.id + '/items')
  },
  showDocumentItem (document_item = {}) {
    return HTTP.get('document-items/' + document_item.id)
  },
  updateDocumentItem (document_item = {}) {
    return HTTP.put('document-items/' + document_item.id, document_item)
  },
  destroyDocumentItem (document_item = {}) {
    return HTTP.delete('document-items/' + document_item.id)
  },
  createDocumentItem (document_item = {}) {
    return HTTP.post('document-items', document_item)
  },
  importDocumentItem (document = {}, file) {
    return HTTP.post('document-items/' + document.id + '/imports', file)
  },
  uploadImageDocumentItem (data) {
    return HTTP.post('documents/upload-images', data)
  },
  updateNodeDocumentItem (data = {}) {
    return HTTP.post('document-items/node', data)
  }
}



// WEBPACK FOOTER //
// ./src/service/document-item.js